var {EventEmitter} = require('fbemitter');
var emitter = new EventEmitter();

export default emitter